import { render, staticRenderFns } from "./EnableWithdrawalSetting.vue?vue&type=template&id=3c494deb&scoped=true"
import script from "./EnableWithdrawalSetting.vue?vue&type=script&lang=js"
export * from "./EnableWithdrawalSetting.vue?vue&type=script&lang=js"
import style0 from "./EnableWithdrawalSetting.vue?vue&type=style&index=0&id=3c494deb&prod&lang=scss&scoped=true"
import style1 from "./EnableWithdrawalSetting.vue?vue&type=style&index=1&id=3c494deb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c494deb",
  null
  
)

export default component.exports